import { useQuery } from '@tanstack/react-query';
import { api } from '@/auth/api';
import type { FleetStats } from '@breaker/shared-types';

export interface StatsRange {
  /** ISO datetimes, computed by the picker. */
  from: string;
  to: string;
}

export function useFleetStats(fleetId: string | null, range: StatsRange | null) {
  return useQuery({
    queryKey: ['stats', fleetId ?? '', range?.from ?? '', range?.to ?? ''] as const,
    enabled: Boolean(fleetId && range),
    queryFn: () =>
      api<{ stats: FleetStats }>(`/v1/fleets/${fleetId}/stats`, {
        query: { from: range!.from, to: range!.to },
      }),
    select: (data) => data.stats,
    staleTime: 60_000,
  });
}
